<div class="row back-top-cta">
    <div class="d-block d-md-none text-center">
        <button class="secondary-cta" (click)="backToTop()">
            {{textCta.Text}}
            <span class="sr-only">{{textCta.AdaText}}</span>
        </button>
    </div>
</div>